import { LogLevel } from '@ng-darwin/config';

export const environment = {
  local: false,
  production: true,
  configLogLevel: LogLevel.ERROR
};
